// 子仓库 - 监控报表
import to from 'await-to-js';
import * as apis from "@/api/interface/monitor";

export default {
  namespaced: true,
  state: () => ({
    loading: {},
    dailyBaseList: undefined, //日 - 数据转化报表 - 列表
    dailyRbList: undefined, //日 - 人保魔方链路转化报表 - 列表
    dailyHnzjList: undefined, //点拨报表 - 转化数据 - 列表
    dailyHnzjBatchJfList: undefined, //点拨报表 - 转化数据 - 点拨数据类型转化报表列表 
    dbSeatSummary: undefined,
    dbSeatCurrentMonthDetail: undefined,
    dbSeatPreviousMonthDetail: undefined,
    dailyJfList: undefined, //日 - 均分坐席人效报表 - 列表
    dailyZxList: undefined, //日 - 0.2意外赠险转均分报表 - 列表
    dailyQywxList: undefined, //日 - 企微运营报表 - 列表
    jssList: undefined, //均分销售转化效率追踪 - 列表
    jssOverview: undefined, //均分销售转化效率追踪 - 概览数据
    detailCoreStats: {}, //均分销售转化效率追踪 - 详情 - 核心指标
    detailCoreCharts: undefined, //均分销售转化效率追踪 - 详情 - 核心图表
    detailCharts: undefined, //均分销售转化效率追踪 - 详情 - 图表
    urgePayList: undefined, //催缴报表 - 列表
    aiLineList: undefined, //AI线路 - 列表
    aiPreCallReport: undefined, //AI转化 预拨测- 列表
    aiTransferReport: undefined, //AI转化 AI转人- 列表
    aiLineCollectList: undefined, //线路汇总 - 列表
    dialogueIntervalTimeWholeStats: undefined,  //对话间隔时长监控 - 整体统计
    dialogueIntervalTimeWholeBarDetail: undefined,  //对话间隔时长监控 - 整体单柱详情
    dialogueIntervalTimeActualStats: undefined,  //对话间隔时长监控 - 实时统计
    seatJfList: undefined,  //坐席均分 - 列表
    mfJfList: undefined,  //魔方转均分AI - 列表
    rxaMaterialReport: undefined,
    rxaEditorReport: undefined,
    rxaWriterReport: undefined,
  }),
  getters: {},
  mutations: {
    update(state, payload) {
      Object.keys(payload).forEach((key) => {
        state[key] = payload[key];
      });
    },
  },
  actions: {
    // 日 - 数据转化报表 - 列表
    async getDailyBaseList(ctx, payload = {}) {
      const [err, res] = await to (apis.getDailyBaseList(payload));
      ctx.commit("update", {
        dailyBaseList: !err && res.data ? res.data : undefined,
      });
      return res;
    },

    // 日 - 人保魔方链路转化报表 - 列表
    async getDailyRbList(ctx, payload = {}) {
      const [err, res] = await to (apis.getDailyRbList(payload));
      ctx.commit("update", {
        dailyRbList: !err && res.data ? res.data : undefined,
      });
      return res;
    },




    // 点拨报表 - 转化数据 - 列表
    async getDailyHnzjList(ctx, payload = {}) {
      const [err, res] = await to (apis.getDailyHnzjList(payload));
      ctx.commit("update", {
        dailyHnzjList: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 点拨报表 - 转化数据 - 点拨数据类型转化报表列表
    async getDailyHnzjBatchList(ctx, payload = {}) {
      const [err, res] = await to (apis.getDailyHnzjBatchList(payload));
      ctx.commit("update", {
        dailyHnzjBatchJfList: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 点拨坐席数据 - 筛选选项
    async getDbSeatOptions(ctx, payload = {}) {
      const [, res] = await to(apis.getDbSeatOptions(payload));
      return res;
    },
    // 点拨坐席数据 - 汇总数据
    async getDbSeatSummary(ctx, payload = {}) {
      const [err, res] = await to(apis.getDbSeatSummary(payload));
      ctx.commit("update", { dbSeatSummary: !err && res && res.data ? res.data : undefined });
      return res;
    },
    // 点拨坐席数据 - 当月明细
    async getDbSeatCurrentMonthDetail(ctx, payload = {}) {
      const [err, res] = await to(apis.getDbSeatCurrentMonthDetail(payload));
      ctx.commit("update", { dbSeatCurrentMonthDetail: !err && res && res.data ? res.data : undefined });
      return res;
    },
    // 点拨坐席数据 - 前月更新明细
    async getDbSeatPreviousMonthDetail(ctx, payload = {}) {
      const [err, res] = await to(apis.getDbSeatPreviousMonthDetail(payload));
      ctx.commit("update", { dbSeatPreviousMonthDetail: !err && res && res.data ? res.data : undefined });
      return res;
    },
    // 点拨坐席数据 - 数据导出
    async exportDbSeatData(_ctx, payload = {}) {
      const [, res] = await to(apis.exportDbSeatData(payload));
      return res;
    },



    // 日 - 均分坐席人效报表 - 列表
    async getDailyJfList(ctx, payload = {}) {
      const [err, res] = await to (apis.getDailyJfList(payload));
      ctx.commit("update", {
        dailyJfList: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 日 - 均分坐席人效报表 - 筛选列表
    async getDailyJfOptions(_, payload = {}) {
      const [, res] = await to (apis.getDailyJfOptions(payload));
      return res;
    },
    // 日 - 均分坐席人效报表 - 数据导出
    async dailyJfExport(ctx, payload = {}) {
      const [, res] = await to(apis.dailyJfExport(payload));
      return res;
    },



    // 日 - 0.2意外赠险转均分报表 - 列表
    async getDailyZxReport(ctx, payload = {}) {
      const [err, res] = await to (apis.getDailyZxReport(payload));
      ctx.commit("update", {
        dailyZxList: !err && res.data ? res.data : undefined,
      });
      return res;
    },

    // 日 - 企微运营报表 - 列表
    async getDailyQywxReport(ctx, payload = {}) {
      const [err, res] = await to (apis.getDailyQywxReport(payload));
      ctx.commit("update", {
        dailyQywxList: !err && res.data ? res.data : undefined,
      });
      return res;
    },



    // 均分销售转化效率追踪 - 列表
    async getJssList(ctx, payload = {}) {
      const [err, res] = await to (apis.getJssList(payload));
      ctx.commit("update", {
        jssList: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 均分销售转化效率追踪 - 数据导出
    async jssExport(ctx, payload = {}) {
      const [, res] = await to(apis.jssExport(payload));
      return res;
    },
    // 均分销售转化效率追踪 - 选项列表
    async getJssOptions(_, payload = {}) {
      const [, res] = await to (apis.getJssOptions(payload));
      return res;
    },
    // 均分销售转化效率追踪 - 概览数据
    async getJssOverview(ctx, payload = {}) {
      const [err, res] = await to (apis.getJssOverview(payload));
      ctx.commit("update", {
        jssOverview: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 均分销售转化效率追踪 - 详情 - 核心指标
    async getDetailCoreStats(ctx, payload = {}) {
      const [err, res] = await to (apis.getDetailCoreStats(payload));
      ctx.commit("update", {
        detailCoreStats: !err && res.data ? res.data : {},
      });
      return res;
    },
    // 均分销售转化效率追踪 - 详情 - 核心图表
    async getDetailCoreCharts(ctx, payload = {}) {
      const [err, res] = await to (apis.getDetailCoreCharts(payload));
      ctx.commit("update", {
        detailCoreCharts: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 均分销售转化效率追踪 - 详情 - 图表
    async getDetailCharts(ctx, payload = {}) {
      const [err, res] = await to (apis.getDetailCharts(payload));
      ctx.commit("update", {
        detailCharts: !err && res.data ? res.data : undefined,
      });
      return res;
    },



    // 催缴报表 - 列表
    async getUrgePayList(ctx, payload = {}) {
      const [err, res] = await to (apis.getUrgePayList(payload));
      ctx.commit("update", {
        urgePayList: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 催缴报表 - 职场选项列表
    async getUrgePayWorkplaceOptions(_, payload = {}) {
      const [, res] = await to (apis.getUrgePayWorkplaceOptions(payload));
      return res;
    },




    // AI报表 - 机构选项列表
    async getAiOrgOptions(_, payload = {}) {
      const [, res] = await to (apis.getAiOrgOptions(payload));
      return res;
    },
    // AI报表 - 线路选项列表
    async getAiLineOptions(_, payload = {}) {
      const [, res] = await to (apis.getAiLineOptions(payload));
      return res;
    },
    // AI报表 - 剧本选项列表
    async getAiLinkScriptNodeOptions(_, payload = {}) {
      const [, res] = await to (apis.getAiLinkScriptNodeOptions(payload));
      return res;
    },
    // AI线路 - 列表
    async getAiLineList(ctx, payload = {}) {
      const [err, res] = await to (apis.getAiLineList(payload));
      ctx.commit("update", {
        aiLineList: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // AI线路 导出
    async aiLineExport(ctx, payload = {}) {
      const [, res] = await to(apis.aiLineExport(payload));
      return res;
    },
    // AI转化 - 列表
    async getAiPreCallReport(ctx, payload = {}) {
      const [err, res] = await to (apis.getAiPreCallReport(payload));
      ctx.commit("update", {
        aiPreCallReport: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // AI转化 导出
    async aiConversionReportsExport(ctx, payload = {}) {
      const [, res] = await to(apis.aiConversionReportsExport(payload));
      return res;
    },
    // AI转化 AI转人- 列表
    async getAiTransferReport(ctx, payload = {}) {
      const [err, res] = await to (apis.getAiTransferReport(payload));
      ctx.commit("update", {
        aiTransferReport: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // AI转化 AI转人 导出
    async aiTransferReportExport(ctx, payload = {}) {
          const [, res] = await to(apis.aiTransferReportExport(payload));
          return res;
    },
    // 线路汇总 - 列表
    async getAiLineCollectList(ctx, payload = {}) {
      const [err, res] = await to (apis.getAiLineCollectList(payload));
      ctx.commit("update", {
        aiLineCollectList: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 线路汇总 导出
    async aiLineCollectExport(ctx, payload = {}) {
      const [, res] = await to(apis.aiLineCollectExport(payload));
      return res;
    },
    // 企微链路-AI - 列表
    async getAiQwLinkList(ctx, payload = {}) {
      const [, res] = await to (apis.getAiQwLinkList(payload));
      return res;
    },
    // 企微链路-职场 - 列表
    async getAiQwLinkJobMarketList(ctx, payload = {}) {
      const [, res] = await to (apis.getAiQwLinkJobMarketList(payload));
      return res;
    },
    // 企微链路 - 职场 - 导出
    async aiQwLinkJobMarketExport(_, payload = {}) {
      const [, res] = await to(apis.aiQwLinkJobMarketExport(payload));
      return res;
    },
    // 对话间隔时长监控 - 整体统计
    async getDialogueIntervalTimeWholeStats(ctx, payload = {}) {
      const [err, res] = await to (apis.getDialogueIntervalTimeWholeStats(payload));
      ctx.commit("update", {
        dialogueIntervalTimeWholeStats: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 对话间隔时长监控 - 整体单柱详情
    async getDialogueIntervalTimeWholeBarDetail(ctx, payload = {}) {
      const [err, res] = await to (apis.getDialogueIntervalTimeWholeBarDetail(payload));
      ctx.commit("update", {
        dialogueIntervalTimeWholeBarDetail: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 对话间隔时长监控 - 实时统计
    async getDialogueIntervalTimeActualStats(ctx, payload = {}) {
      const [err, res] = await to (apis.getDialogueIntervalTimeActualStats(payload));
      ctx.commit("update", {
        dialogueIntervalTimeActualStats: !err && res.data ? res.data : undefined,
      });
      return res;
    },


    // 坐席均分 - 列表
    async getSeatJfList(ctx, payload = {}) {
      const [err, res] = await to (apis.getSeatJfList(payload));
      ctx.commit("update", {
        seatJfList: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 坐席均分 - 坐席选项列表
    async getSeatOptions(_ctx, payload = {}) {
      const [, res] = await to (apis.getSeatOptions(payload));
      return res;
    },

    // 魔方转均分AI - 列表
    async getMfJfList(ctx, payload = {}) {
      const [err, res] = await to (apis.getMfJfList(payload));
      ctx.commit("update", {
        mfJfList: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 魔方转均分AI - 导出
    async mfJfExport(_ctx, payload = {}) {
      const [, res] = await to (apis.mfJfExport(payload));
      return res;
    },
    // 魔方转均分AI - 坐席选项列表
    async getMfJfSeatOptions(_ctx, payload = {}) {
      const [, res] = await to (apis.getMfJfSeatOptions(payload));
      return res;
    },
    async getRxaMaterialReport(ctx, payload = {}) {
      const [err, res] = await to(apis.getRxaMaterialReport(payload));
      ctx.commit('update', {rxaMaterialReport: !err && res.data ? res.data : undefined});
      return res;
    },
    async getRxaEditorReport(ctx, payload = {}) {
      const [err, res] = await to(apis.getRxaEditorReport(payload));
      ctx.commit('update', {rxaEditorReport: !err && res.data ? res.data : undefined});
      return res;
    },
    async getRxaWriterReport(ctx, payload = {}) {
      const [err, res] = await to(apis.getRxaWriterReport(payload));
      ctx.commit('update', {rxaWriterReport: !err && res.data ? res.data : undefined});
      return res;
    },
    async getRxaMaterialReportOptions(_ctx, payload = {}) {
      const [, res] = await to(apis.getRxaMaterialReportOptions(payload)); return res;
    },
    async rxaMaterialReportExport(_ctx, payload = {}) {
      const [, res] = await to(apis.rxaMaterialReportExport(payload)); return res;
    },
    async rxaEditorReportExport(_ctx, payload = {}) {
      const [, res] = await to(apis.rxaEditorReportExport(payload)); return res;
    },
    async rxaWriterReportExport(_ctx, payload = {}) {
      const [, res] = await to(apis.rxaWriterReportExport(payload)); return res;
    },
    async rxaMaterialReportUpload(_ctx, payload = {}) {
      const [, res] = await to(apis.rxaMaterialReportUpload(payload)); return res;
    },
  },
  modules: {},
};
